export default __webpack_public_path__ + "static/media/sentencesinput_standard.77fdcfee.svg";